import { gql } from '@apollo/client';

const SEND_STUDY_REFERENCE_CODE = gql`
  mutation sendStudyReferenceCode($input: SendStudyRefCodeInput!) {
    sendStudyReferenceCode(input: $input) {
      isSuccess
      message
    }
  }
`;

export default SEND_STUDY_REFERENCE_CODE;
